(ns web3.queries.profile
  (:require [x-vec.graphql :as x]
            [web3.persistence.queries :as q]))

(declare query mutation fragment String String! StreetAddressInput
         UUID!
         UserReferralType! URL ProPlan)

;; ========== Profile ==========

(x/def ^fragment referral-link-fields {:on :User}
  :proReferralLinkPath
  :proReferralLink
  :referralLink)

(x/def ^fragment address-fields {:on :StreetAddress}
  :country
  :region
  :locality
  :street1
  :street2
  :postalCode)

(x/def ^fragment profile-fields {:on :Profile}
  :firstName
  :lastName
  :professionName
  :companyName
  :website
  :mobilePhone
  :officePhone
  [:personImage (q/thumbnail-link)]
  [:companyImage (q/thumbnail-link)]
  [:address address-fields])

(x/defn ^mutation profile-update! [{:keys [^String! email
                                           ^String firstName
                                           ^String lastName
                                           ^String professionName
                                           ^String companyName
                                           ^String website
                                           ^String mobilePhone
                                           ^String officePhone
                                           ^StreetAddressInput address
                                           ^URL personImageLink
                                           ^URL companyImageLink
                                           ^String proReferralLinkPath
                                           ^ProPlan proPlan]}]
        [:me_update
         {:email email
          :firstName firstName
          :lastName lastName
          :professionName professionName
          :companyName companyName
          :website website
          :mobilePhone mobilePhone
          :officePhone officePhone
          :address address
          :personImageLink personImageLink
          :companyImageLink companyImageLink
          :proReferralLinkPath proReferralLinkPath
          :proPlan proPlan}
         q/entity-id-fields
         profile-fields
         referral-link-fields
         :email
         :proPlan])

(x/defn ^mutation update-password! [{:keys [^String! currentPassword
                                            ^String! newPassword]}]
        [:me_updatePassword
         {:currentPassword currentPassword
          :newPassword newPassword}
         q/entity-id-fields
         :email
         :firstName
         :lastName])
(x/defn ^mutation generate-ticket! [{:keys [^String! token ]}]
        [:me_generate_ticket
         {:token token
          }
         q/entity-id-fields
         :website
         ])

(x/defn ^mutation create-user-referral! [{:keys [^UUID! id
                                                 ^UserReferralType! type]}]
        [:userReferral_create {:referrerId id
                               :type type}
         [:userReferral
          q/entity-id-fields
          [:referrerEmail]
          [:refereeEmail]]])